import { useRef, useState } from "react";

export default function Upload() {
  const fileInputRef = useRef();

  const [status, setStatus] = useState("");
  const [progress, setProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  const handleUpload = () => {
    const files = fileInputRef.current.files;

    if (!files.length) {
      setStatus("Veuillez sélectionner au moins un fichier.");
      return;
    }

    const formData = new FormData();

    for (const file of files) {
      formData.append("files", file);
    }

    setIsUploading(true);
    setStatus("Envoi en cours…");
    setProgress(0);

    const xhr = new XMLHttpRequest();
    xhr.open("POST", "/api/media/upload");

    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) {
        const percent = Math.round((e.loaded / e.total) * 100);
        setProgress(percent);
      }
    };

    xhr.onload = () => {
      setIsUploading(false);

      if (xhr.status === 200) {
        setStatus("✅ Merci ! Vos fichiers ont été envoyés.");
        fileInputRef.current.value = "";
        setProgress(0);
      } else {
        setStatus("❌ Une erreur est survenue.");
      }
    };

    xhr.onerror = () => {
      setIsUploading(false);
      setStatus("❌ Impossible de contacter le serveur.");
    };

    xhr.send(formData);
  };

  return (
    <div style={styles.page}>
      <h1>📸 Partagez vos souvenirs</h1>
      <p>Ajoutez vos photos et vidéos du mariage</p>

      <div style={styles.box}>
        <input
          ref={fileInputRef}
          type="file"
          multiple
          accept="image/*,video/*"
          style={styles.input}
        />

        <button
          onClick={handleUpload}
          disabled={isUploading}
          style={{
            ...styles.button,
            opacity: isUploading ? 0.5 : 1
          }}
        >
          Envoyer
        </button>

        {isUploading && (
          <div style={styles.progress}>
            <div
              style={{
                ...styles.progressBar,
                width: progress + "%"
              }}
            />
          </div>
        )}

        <div style={styles.status}>{status}</div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    fontFamily: "system-ui, sans-serif",
    background: "#f7f7f7",
    padding: "1.5rem",
    minHeight: "100vh",
    textAlign: "center"
  },
  box: {
    background: "#fff",
    borderRadius: "12px",
    padding: "1.5rem",
    maxWidth: "480px",
    margin: "0 auto",
    boxShadow: "0 10px 25px rgba(0,0,0,0.05)"
  },
  input: {
    width: "100%",
    marginBottom: "1rem"
  },
  button: {
    width: "100%",
    padding: "0.9rem",
    border: "none",
    borderRadius: "8px",
    background: "#000",
    color: "#fff",
    fontSize: "1rem",
    cursor: "pointer"
  },
  progress: {
    height: "6px",
    background: "#eee",
    borderRadius: "4px",
    overflow: "hidden",
    marginTop: "1rem"
  },
  progressBar: {
    height: "100%",
    background: "#000",
    transition: "width 0.2s"
  },
  status: {
    marginTop: "1rem",
    fontSize: "0.9rem"
  }
};